import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 bg-violet-900 text-white border-t border-violet-800" data-id="element-32">
      <div className="max-w-7xl mx-auto text-center" data-id="element-33">
        <p className="text-sm md:text-base" data-id="element-34">
          © 2026 Sharon Tirado · Todos los derechos reservados
        </p>
      </div>
    </footer>;
}